var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconScoreBonus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 114.4 114.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffaa2e;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-3 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-6 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-15 {\n        fill: #703d00;\n      }\n\n      .cls-16 {\n        fill: #ff9912;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 57.2,
    y1: 107,
    x2: 57.2,
    y2: 32.2,
    gradientTransform: "translate(0 116.8) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fde265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f29c14"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 140.1,
    cy: -30.9,
    fx: 140.1,
    fy: -30.9,
    r: 93.4,
    gradientTransform: "translate(-67.8 57.9) scale(.9 -.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbc12a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce7904"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 302.5,
    cy: -89.4,
    fx: 302.5,
    fy: -89.4,
    r: 85.2,
    gradientTransform: "translate(-188.3 -50.4) scale(.8 -.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdd733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce7904"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 55.5,
    y1: 54.7,
    x2: 35.5,
    y2: 68.2,
    gradientTransform: "translate(0 116.8) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdd733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f29c14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 37.3,
    y1: 39.1,
    x2: 55.4,
    y2: 51.9,
    gradientTransform: "translate(0 116.8) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdd733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f29c14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 71,
    y1: 29.1,
    x2: 62.6,
    y2: 54.8,
    gradientTransform: "translate(0 116.8) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f29c14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b26500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 57.2,
    y1: 62.3,
    x2: 82,
    y2: 62.3,
    gradientTransform: "translate(0 116.8) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fced97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdd733"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 61.3,
    y1: 83,
    x2: 52.7,
    y2: 58.4,
    gradientTransform: "translate(0 116.8) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fde265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbc12a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 49.3,
    y1: 62.3,
    x2: 28.9,
    y2: 62.3,
    gradientTransform: "translate(0 116.8) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f29c14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b26500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 44.9,
    y1: 34.8,
    x2: 51.1,
    y2: 52.8,
    gradientTransform: "translate(0 116.8) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f29c14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b26500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 47.9,
    y1: 58.2,
    x2: 74.2,
    y2: 42,
    gradientTransform: "translate(0 116.8) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdd733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f29c14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 57.2,
    y1: 60.8,
    x2: 82,
    y2: 60.8,
    gradientTransform: "translate(0 116.8) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdd733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f29c14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 63.3,
    y1: 58.5,
    x2: 51.8,
    y2: 82.7,
    gradientTransform: "translate(0 116.8) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdd733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f29c14"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.3,98.2c2.5,2,3.2,5.3,3.2,5.3,0,0-3.4,0-6-1.9-2.5-2-3.2-5.3-3.2-5.3,0,0,3.4,0,6,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.2,103.3c3.1-1.1,6.3.1,6.3.1,0,0-1.7,2.9-4.8,4-3.1,1.1-6.3-.1-6.3-.1,0,0,1.7-2.9,4.8-4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.4,95.5c2.2,2.3,2.4,5.7,2.4,5.7,0,0-3.4-.4-5.6-2.7-2.2-2.3-2.4-5.7-2.4-5.7,0,0,3.4.4,5.6,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.6,100.2c3.2-.6,6.2,1,6.2,1,0,0-2.1,2.6-5.3,3.3-3.2.6-6.2-1-6.2-1,0,0,2.1-2.6,5.3-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.6,91.6c1.8,2.6,1.5,6,1.5,6,0,0-3.3-.9-5.1-3.5-1.8-2.6-1.5-6-1.5-6,0,0,3.3.9,5.1,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.1,95.7c3.2-.1,6,1.9,6,1.9,0,0-2.5,2.3-5.8,2.4-3.2.1-6-1.9-6-1.9,0,0,2.5-2.3,5.8-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.3,85.8c1.1,3,0,6.2,0,6.2,0,0-3-1.7-4.1-4.7-1.1-3,0-6.2,0-6.2,0,0,3,1.7,4.1,4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19,88.6c3.2.6,5.3,3.3,5.3,3.3,0,0-3,1.6-6.2,1-3.2-.6-5.3-3.3-5.3-3.3,0,0,3-1.6,6.2-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.8,79c.4,3.2-1.5,6-1.5,6,0,0-2.5-2.3-2.9-5.5-.4-3.2,1.5-6,1.5-6,0,0,2.5,2.3,2.9,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13,80.5c2.9,1.4,4.4,4.4,4.4,4.4,0,0-3.3.9-6.3-.5-2.9-1.4-4.4-4.4-4.4-4.4,0,0,3.3-.9,6.3.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.2,70.4c-.3,3.2-2.7,5.6-2.7,5.6,0,0-2-2.8-1.7-5.9.3-3.2,2.7-5.6,2.7-5.6,0,0,2,2.8,1.7,5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.1,70.8c2.6,1.9,3.4,5.2,3.4,5.2,0,0-3.4.2-6-1.7-2.6-1.9-3.4-5.2-3.4-5.2,0,0,3.4-.2,6,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.7,62.3c-.8,3.1-3.6,5.1-3.6,5.1,0,0-1.5-3-.7-6.1.8-3.1,3.6-5.1,3.6-5.1,0,0,1.5,3,.7,6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.7,61.7c2.3,2.3,2.5,5.7,2.5,5.7,0,0-3.4-.3-5.7-2.6-2.3-2.3-2.5-5.7-2.5-5.7,0,0,3.4.3,5.7,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.5,53.2c-1.5,2.8-4.7,4.1-4.7,4.1,0,0-.7-3.3.8-6.1,1.5-2.8,4.7-4.1,4.7-4.1,0,0,.7,3.3-.8,6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.7,51.2c1.6,2.8,1,6.1,1,6.1,0,0-3.2-1.1-4.9-3.9-1.6-2.8-1-6.1-1-6.1,0,0,3.2,1.1,4.9,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.1,44c-2.1,2.4-5.5,2.9-5.5,2.9,0,0,0-3.4,2.2-5.8,2.1-2.4,5.5-2.9,5.5-2.9,0,0,0,3.4-2.2,5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,40.7c.9,3.1-.4,6.2-.4,6.2,0,0-2.9-1.9-3.8-4.9-.9-3.1.4-6.2.4-6.2,0,0,2.9,1.9,3.8,4.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.4,36.5c-2.6,1.8-6.1,1.6-6.1,1.6,0,0,.9-3.3,3.5-5.1,2.6-1.8,6.1-1.6,6.1-1.6,0,0-.9,3.3-3.5,5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.2,32.1c.2,3.2-1.9,5.9-1.9,5.9,0,0-2.4-2.5-2.5-5.6-.2-3.2,1.9-5.9,1.9-5.9,0,0,2.4,2.5,2.5,5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.6,29.7c-2.9,1.4-6.2.6-6.2.6,0,0,1.4-3.1,4.3-4.5,2.9-1.4,6.2-.6,6.2-.6,0,0-1.4,3.1-4.3,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.1,24.7c-.3,3.2-2.8,5.5-2.8,5.5,0,0-1.9-2.8-1.6-6,.3-3.2,2.8-5.5,2.8-5.5,0,0,1.9,2.8,1.6,6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.9,97.7c-2.5,2-3.2,5.3-3.2,5.3,0,0,3.4,0,6-1.9,2.5-2,3.2-5.3,3.2-5.3,0,0-3.4,0-6,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.9,102.9c-3.1-1.1-6.3.1-6.3.1,0,0,1.7,2.9,4.8,4,3.1,1.1,6.3-.1,6.3-.1,0,0-1.7-2.9-4.8-4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.5,95.5c-2.2,2.3-2.4,5.7-2.4,5.7,0,0,3.4-.4,5.6-2.7,2.2-2.3,2.4-5.7,2.4-5.7,0,0-3.4.4-5.6,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.3,100.2c-3.2-.6-6.2,1-6.2,1,0,0,2.1,2.6,5.3,3.3,3.2.6,6.2-1,6.2-1,0,0-2.1-2.6-5.3-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.3,91.3c-1.8,2.6-1.5,6-1.5,6,0,0,3.3-.9,5.1-3.5,1.8-2.6,1.5-6,1.5-6,0,0-3.3.9-5.1,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.7,95.4c-3.2-.1-6,1.9-6,1.9,0,0,2.5,2.3,5.8,2.4,3.2.1,6-1.9,6-1.9,0,0-2.5-2.3-5.8-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.3,85.6c-1.1,3,0,6.2,0,6.2,0,0,3-1.7,4.1-4.7,1.1-3,0-6.2,0-6.2,0,0-3,1.7-4.1,4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.6,88.5c-3.2.6-5.3,3.3-5.3,3.3,0,0,3,1.6,6.2,1,3.2-.6,5.3-3.3,5.3-3.3,0,0-3-1.6-6.2-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.1,78.3c-.4,3.2,1.5,6,1.5,6,0,0,2.5-2.3,2.9-5.5.4-3.2-1.5-6-1.5-6,0,0-2.5,2.3-2.9,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102,79.9c-2.9,1.4-4.4,4.4-4.4,4.4,0,0,3.3.9,6.3-.5,2.9-1.4,4.4-4.4,4.4-4.4,0,0-3.3-.9-6.3.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.2,70.3c.3,3.2,2.7,5.6,2.7,5.6,0,0,2-2.8,1.7-5.9-.3-3.2-2.7-5.6-2.7-5.6,0,0-2,2.8-1.7,5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.3,70.6c-2.6,1.9-3.4,5.2-3.4,5.2,0,0,3.4.2,6-1.7,2.6-1.9,3.4-5.2,3.4-5.2,0,0-3.4-.2-6,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.7,62.1c.8,3.1,3.5,5.1,3.5,5.1,0,0,1.5-3,.7-6.1-.8-3.1-3.6-5.1-3.6-5.1,0,0-1.5,3-.7,6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.7,61.5c-2.3,2.3-2.5,5.7-2.5,5.7,0,0,3.4-.3,5.7-2.6,2.3-2.3,2.5-5.7,2.5-5.7,0,0-3.4.3-5.7,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.9,53.3c1.5,2.8,4.7,4.1,4.7,4.1,0,0,.7-3.3-.8-6.1-1.5-2.8-4.7-4.1-4.7-4.1,0,0-.7,3.3.8,6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.6,51.3c-1.6,2.8-1,6.1-1,6.1,0,0,3.2-1.1,4.9-3.9,1.6-2.8,1-6.1,1-6.1,0,0-3.2,1.1-4.9,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.2,44.1c2.1,2.4,5.5,2.9,5.5,2.9,0,0,0-3.4-2.2-5.8-2.1-2.4-5.5-2.9-5.5-2.9,0,0,0,3.4,2.2,5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.3,40.9c-.9,3.1.4,6.2.4,6.2,0,0,2.9-1.9,3.8-4.9.9-3.1-.4-6.2-.4-6.2,0,0-2.9,1.9-3.8,4.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98,36.7c2.6,1.8,6.1,1.6,6.1,1.6,0,0-.9-3.3-3.5-5.1-2.6-1.8-6.1-1.6-6.1-1.6,0,0,.9,3.3,3.5,5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.2,32.4c-.2,3.2,1.9,5.9,1.9,5.9,0,0,2.4-2.5,2.5-5.6.2-3.2-1.9-5.9-1.9-5.9,0,0-2.4,2.5-2.5,5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.6,30c2.9,1.4,6.2.6,6.2.6,0,0-1.4-3.1-4.3-4.5-2.9-1.4-6.2-.6-6.2-.6,0,0,1.4,3.1,4.3,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97,25c.3,3.2,2.8,5.5,2.8,5.5,0,0,1.9-2.8,1.6-6s-2.8-5.5-2.8-5.5c0,0-1.9,2.8-1.6,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M91.2,20.2c-.1.1-.3.3-.5.4,0,0-.1,0-.2,0,10.2,8.7,16.6,21.2,16.6,35.1,0,26.1-22.5,47.3-50.1,47.3S7.1,81.9,7.1,55.8s5.8-25.3,15.2-33.9c-.3,0-.5-.2-.8-.3-9.4,8.7-15.2,20.9-15.2,34.2,0,26.5,22.8,48,50.9,48s50.9-21.5,50.9-48-6.5-26.8-16.8-35.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.3,23.6c-3.2.7-6.2-.9-6.2-.9,0,0,2.1-2.7,5.3-3.3,3.2-.7,6.2.9,6.2.9,0,0-2.1,2.7-5.3,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.2,18c-1.1,3-4.1,4.7-4.1,4.7,0,0-1.2-3.2,0-6.2,1.1-3,4.1-4.7,4.1-4.7,0,0,1.2,3.2,0,6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.2,23.6c3.2.7,6.2-.9,6.2-.9,0,0-2.1-2.7-5.3-3.3-3.2-.7-6.2.9-6.2.9,0,0,2.1,2.7,5.3,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.3,18c1.1,3,4.1,4.7,4.1,4.7,0,0,1.2-3.2,0-6.2-1.1-3-4.1-4.7-4.1-4.7,0,0-1.2,3.2,0,6.2Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode",
    "data-name": "Isolation Mode"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 57.2,
    cy: 56,
    r: 39.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 57.2,
    cy: 56,
    r: 35.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 57.2,
    cy: 56,
    r: 32.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "57.2 58.5 57.2 58.5 47.7 61.6 32.4 50.4 57.2 58.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "57.2 58.5 57.2 68.5 41.8 79.6 57.2 58.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "66.7 61.6 72.5 79.6 57.2 58.5 57.2 58.5 66.7 61.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "82 50.4 57.2 58.5 63.1 50.4 82 50.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "57.2 32.4 57.2 58.5 57.2 58.5 51.3 50.4 57.2 32.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "51.3 50.4 57.2 58.5 32.4 50.4 51.3 50.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "57.2 58.5 41.8 79.6 47.7 61.6 57.2 58.5 57.2 58.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "57.2 58.5 72.5 79.6 57.2 68.5 57.2 58.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "82 50.4 66.7 61.6 57.2 58.5 57.2 58.5 82 50.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "57.2 32.4 63.1 50.4 57.2 58.5 57.2 58.5 57.2 32.4"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "79 51.4 62.3 51.4 57.2 35.6 52 51.4 35.4 51.4 48.9 61.2 43.7 77.1 57.2 67.3 70.7 77.1 65.5 61.2 79 51.4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScoreBonus);
export default __webpack_public_path__ + "static/media/icon-score-bonus.a794648c1edc80aaca6034414bcd7b30.svg";
export { ForwardRef as ReactComponent };